import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react'
import type { BridgeConfigsResponseSchema } from '@rhinofi/bridge-api-spec'
import { apiSpec } from '@rhinofi/bridge-api-spec'
import { Effect } from 'effect'
import { HttpApiClient } from 'effect/http-api'
import { envConfig } from '../../env/envConfig'
import { runApiRequest } from '../../services/api/runApiRequest'

const apiClient = HttpApiClient.make(apiSpec, { baseUrl: `${envConfig.tradingApi}/bridge` })

export const configApi = createApi({
  reducerPath: 'configApi',
  baseQuery: fetchBaseQuery({}),
  endpoints: (builder) => ({
    getConfig: builder.query<BridgeConfigsResponseSchema, void>({
      queryFn: () => runApiRequest(apiClient.pipe(Effect.flatMap((client) => client.configs.configs()))),
    }),
  }),
})

export const { useLazyGetConfigQuery } = configApi
